module.exports = {
  title: '用户登录',
  route: {
    path: '/login',
  },
};
